import { NotificationsOutlined } from '@mui/icons-material';
import { CandidateViewModel } from 'features/profile/types';
import { useTranslation } from 'react-i18next';
import { EntityViewSectionTitle, InfoLine } from 'shared/components/layout/entityView';

import PreferenceStatus from './PreferenceStatus';

export interface CommunicationPreferencesSectionProps {
    preferences: CandidateViewModel['communicationPreferences'];
}

export default function CommunicationPreferencesSection({ preferences }: CommunicationPreferencesSectionProps) {
    const { t } = useTranslation('profile');

    // When globally unsubscribed, specific subscriptions are not effective even if their flags are set.
    const globallySubscribed = preferences.unspecified;

    return (
        <>
            <EntityViewSectionTitle
                title={ t('view.sections.communicationPreferences') }
                icon={ <NotificationsOutlined /> }
            />

            <InfoLine
                title={ t('view.communicationPreferences.allEmails.title') }
                description={ t('view.communicationPreferences.allEmails.description') }
                trailing={ <PreferenceStatus enabled={ preferences.unspecified } /> }
            />
            <InfoLine
                title={ t('view.communicationPreferences.engagementCampaign.title') }
                description={ t('view.communicationPreferences.engagementCampaign.description') }
                trailing={ <PreferenceStatus enabled={ globallySubscribed && preferences.engagementCampaign } /> }
            />
            <InfoLine
                title={ t('view.communicationPreferences.candidateAvailabilityRequests.title') }
                description={ t('view.communicationPreferences.candidateAvailabilityRequests.description') }
                trailing={ <PreferenceStatus enabled={ globallySubscribed && preferences.candidateAvailabilityRequests } /> }
            />
            <InfoLine
                title={ t('view.communicationPreferences.candidateNotificationAboutOrders.title') }
                description={ t('view.communicationPreferences.candidateNotificationAboutOrders.description') }
                trailing={ <PreferenceStatus enabled={ globallySubscribed && preferences.candidateNotificationAboutOrders } /> }
            />
            <InfoLine
                title={ t('view.communicationPreferences.candidateJobPreferencesUpdateRequest.title') }
                description={ t('view.communicationPreferences.candidateJobPreferencesUpdateRequest.description') }
                trailing={ <PreferenceStatus enabled={ globallySubscribed && preferences.candidateJobPreferencesUpdateRequest } /> }
            />
        </>
    );
}
